module.exports = __webpack_public_path__ + "fonts/montserrat-latin-900italic.4454c77.woff2";